document.addEventListener("DOMContentLoaded", function () {
  const cfTurnstileKey = document.getElementById("cf-sitekey");
  var submitButton = document.getElementById("edge_registration_submit");

  // Function to enable the submit button
  function enableSubmitButton() {
    submitButton.removeAttribute("disabled");
  }

  // Cloudflare Turnstile callback function
  function onTurnstileSuccess(token) {
    enableSubmitButton();
  }

  if (cfTurnstileKey) {
    // Initialize Cloudflare Turnstile
    turnstile.render(".turnstile", {
      sitekey: cfTurnstileKey.getAttribute("data-sitekey"),
      callback: onTurnstileSuccess,
    });
  }
});
